import { useEffect, useRef, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Loader from "components/loader/loader";
import { useDispatch, useSelector } from "react-redux";
import MUIDataTable from "mui-datatables";
import { Tooltip } from "@mui/material";
import moment from "moment/moment";
import { getMomentFormat } from "constants/dateTime.constant";
import { getContractList } from "store";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import AdrenaInput from "components/adrenaInput";
export default function ContractList() {
  var page = 1;
  const perPage = 10;
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  var searchInputRef = useRef();
  const [isLoading, setIsLoading] = useState(true);
  const { contractListData, totalContractsCount } = useSelector((state) => state.couponSlice);
  const [perPageRows, setNumberOfRows] = useState(perPage);
  const [pageCheck, setPageCheck] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  useEffect(() => {
    if (contractListData) {
      setIsLoading(false);
    }
  }, [contractListData]);
  useEffect(() => {
    fetchContractList();
  }, []);

  const fetchContractList = (page, numberOfRows) => {
    let data = {
      page: page ? page : 1,
      perPage: numberOfRows ? numberOfRows : 10,
      language: i18n?.language,
      search: searchInputRef.current.value
    };
    dispatch(getContractList(data, setIsLoading));
  };
  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
    if (e.target.value.length > 2) {
      fetchContractList(page);
    } else if (e.target.value.length === 0) {
      fetchContractList(page);
    }
  };
  const clearSearch = () => {
    setSearchValue("");
    var data = {
      page: 1,
      limit: 10,
      search: "",
      perPage: 10
    };
    dispatch(getContractList(data, setIsLoading));
  };
  const options = {
    count: totalContractsCount,
    filter: false,
    pagination: true,
    selectableRows: "none",
    usePaperPlaceholder: false,
    elevation: 0,
    filterType: "dropdown",
    responsive: "vertical",
    print: false,
    download: false,
    viewColumns: false,
    search: false,
    serverSide: true,
    rowsPerPage: perPageRows,
    rowsPerPageOptions: [10, 20, 50, 100],
    textLabels: {
      pagination: {
        next: "Next",
        previous: "Previous",
        rowsPerPage: t("category.rowsPerPage"),
        displayRows: "of"
      },
      body: {
        noMatch: `Record Not Found`,
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort for ${column.label}`
      }
    },
    onChangePage(currentPage) {
      if (currentPage >= pageCheck) {
        if (currentPage === 0) {
          currentPage = currentPage + 1;
        }
        setPageCheck(currentPage);
        page = currentPage + 1;
        fetchContractList(page, "");
      } else {
        if (pageCheck > 0) {
          page = pageCheck - 1;
        }
        setPageCheck(page);
        fetchContractList(page, "");
      }
    },
    onChangeRowsPerPage(numberOfRows) {
      setNumberOfRows(numberOfRows);
      fetchContractList(page, numberOfRows);
    }
  };
  const columns = [
    {
      name: "productTitle",
      label: t("refund.productName"),
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <Tooltip title={value}>
              <Typography
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  maxWidth: 140,
                  fontSize: 14
                }}>
                {value.charAt(0).toUpperCase() + value.slice(1)}
              </Typography>
            </Tooltip>
          );
        }
      }
    },
    {
      name: "buyerName",
      label: t("contract.buyer"),
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <Tooltip title={value}>
              <Typography
                style={{
                  fontSize: 14
                }}>
                {value}
              </Typography>
            </Tooltip>
          );
        }
      }
    },
    {
      name: "sellerName",
      label: t("contract.seller"),
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <Tooltip title={value}>
              <Typography
                style={{
                  fontSize: 14
                }}>
                {value}
              </Typography>
            </Tooltip>
          );
        }
      }
    },
    {
      name: "productPrice",
      label: t("refund.productPrice"),
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <Tooltip title={value}>
              <Typography
                style={{
                  fontSize: 14
                }}>
                {value ? value : "-"}
              </Typography>
            </Tooltip>
          );
        }
      }
    },
    {
      name: "status",
      label: t("contract.status"),
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <Tooltip title={value}>
              <Typography
                style={{
                  fontSize: 14
                }}>
                {value ? value : "-"}
              </Typography>
            </Tooltip>
          );
        }
      }
    },

    {
      name: "createdAt",
      label: t("products.createdAt"),
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          var localTime = moment.utc(value).toDate();
          return <div style={{ alignItems: "center" }}>{getMomentFormat(localTime)}</div>;
        }
      }
    },
    {
      name: "pdfUrl",
      label: t("contract.viewContract"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => {
          return (
            <>
              {value ? (
                <Link to={value} target="_blank">
                  <Icon icon="carbon:view" color="red" height="20px" width="30px" />
                </Link>
              ) : (
                <Icon icon="carbon:view" height="20px" width="30px" />
              )}
            </>
          );
        }
      }
    }
  ];

  return (
    <>
      <Grid container>
        <Grid
          container
          sx={{
            border: " 1px solid rgba(224, 224, 224, 1)",
            p: 2,
            backgroundColor: "white"
          }}>
          <Typography variant="body1" sx={{ fontSize: 18 }} color="secondary.contrastText">
            {t("contract.list")}
          </Typography>
        </Grid>
        <Grid
          container
          sx={{
            border: " 1px solid rgba(224, 224, 224, 1)",
            p: 2,
            backgroundColor: "white"
          }}>
          <Grid xs={3}>
            <AdrenaInput
              onKeyUp={(event) => {
                if (event.key === "Enter") {
                  fetchContractList(page);
                }
              }}
              inputRef={searchInputRef}
              title={t("contract.searchContract")}
              type="email"
              endIcon={
                searchValue && (
                  <Icon
                    icon="material-symbols:cancel"
                    style={{ cursor: "pointer" }}
                    color="red"
                    onClick={() => clearSearch()}
                  />
                )
              }
              onChange={handleSearchChange}
              value={searchValue}
            />
          </Grid>
        </Grid>
        {isLoading ? (
          <Grid
            container
            sx={{
              border: "1px solid rgba(224, 224, 224, 1)",
              mt: 2,
              height: 300,
              backgroundColor: "white"
            }}>
            <Grid xs={12} style={{ display: "flex", justifyContent: "center" }}></Grid>
          </Grid>
        ) : (
          <>
            {contractListData && contractListData.length > 0 ? (
              <Grid container>
                <Grid xs={12}>
                  <MUIDataTable
                    // title={"Events List"}
                    data={contractListData}
                    columns={columns}
                    options={options}
                  />
                </Grid>
              </Grid>
            ) : (
              <>
                <Grid
                  container
                  sx={{
                    border: "1px solid rgba(224, 224, 224, 1)",
                    mt: 2,
                    height: 300,
                    backgroundColor: "white"
                  }}>
                  <Grid xs={12} style={{ display: "flex", justifyContent: "center" }}>
                    <Typography sx={{ fontSize: 24, fontWeight: 500, mt: "7.5rem" }}>
                      {t("category.noRecordFound")}
                    </Typography>
                  </Grid>
                </Grid>
              </>
            )}
          </>
        )}

        {isLoading && <Loader open={isLoading} text={"Please Wait"} />}
      </Grid>
    </>
  );
}
